import { useEffect, useState, useCallback } from "react";
import { getWaiversByHistorytId } from "../../api/historyService";
import { getWaiversByHistoryEntrytId } from "../../api/historyService";
import { getWaiversByPetId } from "../../api/historyService";
export const useWaivers = (historyId, entryId, petId, mode, trigger, initialPage = 1, initialLimit = 10) => {
    const [waivers, setDocumenations] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'pet') {
                response = await getWaiversByPetId(petId, page, limit);
              }
              else {
                if (entryId)
                {
                  response = await getWaiversByHistoryEntrytId(entryId, page, limit);
                }
                else {
                  response = await getWaiversByHistorytId(historyId, page, limit);
                }
              }
              setDocumenations(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch inventory items:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = waivers.pagination.page + 1;
        if (nextPage <= waivers.pagination.totalPages) {
        await fetchData(nextPage, waivers.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, waivers.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { waivers, loading, loadMore, searchFunction, resetParent };
};